// extracted by mini-css-extract-plugin
export default {"menubarButton":"menubar__menubarButton___Qn3D9"};